import script from "./JapanPowerWeek2025Form.vue?vue&type=script&setup=true&lang=js"
export * from "./JapanPowerWeek2025Form.vue?vue&type=script&setup=true&lang=js"

import "./JapanPowerWeek2025Form.vue?vue&type=style&index=0&id=8dd45a42&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-8dd45a42"]])

export default __exports__